const clockSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="24.259px" height="24.26px" viewBox="0 0 24.259 24.26" enable-background="new 0 0 24.259 24.26" xml:space="preserve">
<g id="Layer_1">
	<g>
		<g>
			<path fill="#FFFFFF" d="M12.128,0C5.444,0,0,5.444,0,12.13c0,6.683,5.444,12.13,12.128,12.13c6.686,0,12.131-5.447,12.131-12.13
				C24.259,5.444,18.813,0,12.128,0z M12.128,22.421c-5.684,0-10.292-4.608-10.292-10.291c0-5.688,4.608-10.294,10.292-10.294
				c5.687,0,10.293,4.606,10.293,10.294C22.421,17.813,17.814,22.421,12.128,22.421z"/>
			<polygon fill="#FFFFFF" points="13.023,5.837 12.023,5.837 12.023,13.167 12.023,14.837 19.023,14.837 19.023,12.837 
				13.023,12.837 			"/>
		</g>
	</g>
</g>
<g id="LiveTXT" display="none">
</g>
<g id="GRids">
</g>
</svg>
`;

export default clockSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/clockSVG.js